export default __webpack_public_path__ + "static/media/share-icon.d666b24f.svg";